/**
 * Sticky header
 */

let offsetTopHeader = 0;
const sectionHeader = document.querySelector('.section-header');
document.getElementsByTagName('html')[0].style = '--main-header-height: ' + sectionHeader.offsetHeight + 'px;';

if (document.querySelector('[data-header-sticky="true"]')) {
	offsetTopHeader = document.querySelector('[data-header-sticky="true"]').offsetTop;
}

document.addEventListener('scroll', (event) => {
	/**
	 * Sticky header mobile
	 */

	const header = document.querySelector('.tpt-header');

	const headerOffsetTop = header.offsetTop;
	const headerHeight = header.offsetHeight;

	const offset = headerOffsetTop + headerHeight;

	header.style.height = headerHeight + 'px';

	if (this.scrollY >= offset) {
		document.querySelector('body').classList.add('header-mobile__sticky');
	} else {
		document.querySelector('body').classList.remove('header-mobile__sticky');
	}
});

/**
 * get height header
 */
function getHeaderHeight() {
	const headerHeight = document.querySelector('.tpt-header-group__wrapper').offsetHeight;
	document.querySelector('.tpt-header-group').style = '--header-height: ' + headerHeight + 'px';
}

/**
 * Update qty mobile - sticky bottom
 */

function updateQtyMobile() {
	let qtyCart = '0';

	if (document.querySelector('.mobile-cart .cart-count-bubble')) {
		qtyCart = document.querySelector('.cart-count-bubble span:first-child').innerText;
	}

	if (document.querySelector('.bottom-mobile_items .cart-count-bubble span')) {
		document.querySelector('.bottom-mobile_items .cart-count-bubble span').innerHTML = qtyCart;
	}
}

/**
 * get height header
 */

function bodyMaxWidth() {
	const documentWidth = document.documentElement.clientWidth;
	const styleString = '--document-width:' + documentWidth + 'px';

	document.body.setAttribute('style', styleString);
}

window.addEventListener('resize', function () {
	setTimeout(() => {
		bodyMaxWidth();
		getHeaderHeight();
	}, 1000);
});

window.addEventListener('DOMContentLoaded', function () {
	bodyMaxWidth();
	getHeaderHeight();

	/**
	 * Toogle block footer
	 */

	const blockFooterHeading = document.querySelectorAll('.footer-block .footer-block_text');

	blockFooterHeading.forEach((item) => {
		item.addEventListener('click', () => {
			item.closest('.footer-block').classList.toggle('active');
		});
	});

	/**
	 * Toogle category mobile
	 */

	const itemCatParent = document.querySelectorAll('.mobile-parent__item');
	itemCatParent.forEach((item) => {
		item.addEventListener('click', () => {
			item.closest('.megamenu-category-item').classList.toggle('active');
		});
	});
});

/**
 * Section lady load
 */
function secsionLadyLoad() {
	let parentSection = '';
	const section = document.querySelector('[data-ladyload="true"]');

	if (section) {
		parentSection = section.closest('.shopify-section');
	}

	if (section) {
		const elementId = section.getAttribute('id');
		const sectionId = elementId.substring(16);
		const urlFetchSectionId = window.Shopify.routes.root + '?section_id=' + sectionId;

		if (!section.classList.contains('loaded')) {
			section.classList.add('loaded');

			fetch(urlFetchSectionId)
				.then((response) => response.text())
				.then((responseText) => {
					const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
					setTimeout(() => {
						sectionElement = responseHTML.querySelector('section[id^="shopify-section-"]');

						section.innerHTML = sectionElement.innerHTML;
						section.querySelectorAll('script').forEach((oldScriptTag) => {
							const newScriptTag = document.createElement('script');
							Array.from(oldScriptTag.attributes).forEach((attribute) => {
								newScriptTag.setAttribute(attribute.name, attribute.value);
							});
							newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
							oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
						});

						section.setAttribute('data-ladyload', 'false');

						/**
						 * Fix lazyload image with RTL layout
						 */
						if (parentSection && document.querySelector('body').classList.contains('layout-rtl')) {
							const imagesLazy = parentSection.querySelectorAll('img');

							imagesLazy.forEach((image) => {
								if (image.getAttribute('loading') == 'lazy') {
									image.setAttribute('loading', 'loaded');
								}
							});
						}
					}, 50);
				})
				.finally(() => {
					if (document.querySelector('[data-fancybox]')) {
						Fancybox.bind('[data-fancybox="gallery"]', {});
					}
				});
		}
	}
}

let defaultDocumentTop = 0;

document.addEventListener('scroll', (event) => {
	secsionLadyLoad();

	if (this.scrollY >= 200) {
		document.querySelector('body').classList.add('scroll-start');
	} else {
		document.querySelector('body').classList.remove('scroll-start');
	}
});

/**
 * Fix image lazyload with swipper slider and RTL layout
 */

const interSection = new IntersectionObserver((entries) => {
	entries.forEach((entry) => {
		if (entry.intersectionRatio > 0) {
			entry.target.querySelectorAll('img').forEach((image) => {
				if (image.getAttribute('loading') == 'lazy') {
					image.setAttribute('loading', 'loaded');
				}
			});
		}
	});
});

if (document.querySelector('body').classList.contains('layout-rtl')) {
	const swiperSlider = document.querySelectorAll('tpt-slider-component');

	swiperSlider.forEach((slider) => {
		interSection.observe(slider);
	});
}

/**
 * Dropdown megamenu mobile
 */

class DropdownMegamenuMobile extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('click', this.showDropdownMegamenuMobile.bind(this));
	}

	showDropdownMegamenuMobile() {
		const btnDropdown = this;
		const menuItem = btnDropdown.closest('.has-dropdown');
		menuItem.classList.add('show-dropdown');

		setTimeout(function () {
			menuItem.classList.add('animate');
		}, 10);
	}
}

customElements.define('dropdown-megamenu-item', DropdownMegamenuMobile);

class BackDropdownMegamenu extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('click', this.backToMegamenuItem.bind(this));
	}

	backToMegamenuItem() {
		const btnBack = this;
		const menuItem = btnBack.closest('.has-dropdown');
		menuItem.classList.remove('animate');

		setTimeout(function () {
			menuItem.classList.remove('show-dropdown');
		}, 300);
	}
}

customElements.define('back-to-item', BackDropdownMegamenu);

/**
 * Sticky product add to cart
 */
class StickyProductAddToCart extends HTMLElement {
	constructor() {
		super();

		const btnChangeQty = this.querySelectorAll('.quantity__button');
		const btnStickyAddCart = this.querySelector('.sticky-add-cart');

		btnStickyAddCart.addEventListener('click', this.addToCart);

		btnChangeQty.forEach((btn) => {
			btn.addEventListener('click', this.changeQty);
		});
	}

	changeQty() {
		const inputQty = this.closest('tpt-quantity-input').querySelector('[name="quantity"]');
		const mainInput = document.querySelector('product-info quantity-input [name="quantity"]');
		let stickyInputValue = parseInt(inputQty.value);

		if (this.getAttribute('name') == 'plus') {
			stickyInputValue = stickyInputValue + 1;
		} else {
			if (parseInt(inputQty.value) > 1) {
				stickyInputValue = stickyInputValue - 1;
			}
		}

		inputQty.value = stickyInputValue;
		mainInput.value = stickyInputValue;
	}

	addToCart() {
		//this.classList.add('loading');
		const productInfo = document.querySelector('.product__info-wrapper');
		productInfo.scrollIntoView({
			behavior: 'smooth',
		});

		document.querySelector('product-info product-form .product-form__submit').click();
	}
}

customElements.define('tpt-quantity-input', StickyProductAddToCart);

function showStickyAddCart() {
	let offsetTop = document.querySelector('product-info product-form').offsetTop;
	let documentTop = document.documentElement.scrollTop;
	const stickyAddCart = document.querySelector('.sticky-button-cart');

	if (documentTop > offsetTop + 400) {
		stickyAddCart.classList.add('active');
		document.body.classList.add('show-sticky-add-cart');
	} else {
		stickyAddCart.classList.remove('active');
		document.body.classList.remove('show-sticky-add-cart');
	}
}

document.addEventListener('scroll', (event) => {
	if (document.querySelector('.sticky-button-cart')) {
		showStickyAddCart();
	}
});

/**
 * Back to top
 */

function toTop() {
	window.scrollTo({ top: 0, behavior: 'smooth' });
}

document.addEventListener('scroll', (event) => {
	const backToTop = document.querySelector('tpt-back-to-top');

	if (backToTop) {
		if (this.scrollY > 800) {
			backToTop.classList.add('active');
		} else {
			backToTop.classList.remove('active');
		}
	}
});

class BackToTop extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('click', toTop);
		this.addEventListener('keypress', this.keyPress);
	}

	keyPress(e) {
		if (e.key === 'Enter') {
			toTop();
		}
	}
}

customElements.define('tpt-back-to-top', BackToTop);

/**
 * View more
 */
class ViewMore extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('click', this.viewMore.bind(this));
	}

	viewMore() {
		this.classList.toggle('active');
		this.closest('.has-more').classList.toggle('active');
	}
}

customElements.define('tpt-viewmore', ViewMore);

/**
 * Close newsletter
 */
class CloseNewsletter extends HTMLElement {
	constructor() {
		super();

		if (!sessionStorage.getItem('closeNewsletter')) {
			this.closest('.newsletter-popup_button').style.display = 'block';
		}

		this.addEventListener('click', this.closeNewsletter.bind(this));
		this.addEventListener('keypress', this.keyPress);
	}

	keyPress(e) {
		if (e.key === 'Enter') {
			this.closeNewsletter();
		}
	}

	closeNewsletter() {
		this.closest('.newsletter-popup_button').style.display = 'none';
		sessionStorage.setItem('closeNewsletter', 'true');
	}
}

customElements.define('tpt-close-newsletter', CloseNewsletter);

/**
 * Toggle password
 */

if (!customElements.get('tpt-toggle-password')) {
	customElements.define(
		'tpt-toggle-password',
		class TptTogglePassword extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.togglePassword.bind(this));
				this.addEventListener('keypress', this.keyPress);
			}

			keyPress(e) {
				if (e.key === 'Enter') {
					this.togglePassword();
				}
			}

			togglePassword() {
				if (this.closest('.input-password').classList.contains('active')) {
					this.closest('.input-password').classList.remove('active');
					this.closest('.input-password').querySelector('input[type="text"]').setAttribute('type', 'password');
					return;
				} else {
					this.closest('.input-password').classList.add('active');
					this.closest('.input-password').querySelector('input[type="password"]').setAttribute('type', 'text');
					return;
				}
			}
		}
	);
}

/**
 * Toggle search mobile
 */

if (!customElements.get('tpt-toggle-search-mobile')) {
	customElements.define(
		'tpt-toggle-search-mobile',
		class TptVisualSearchBanner extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.toggleSearchMobile.bind(this));
			}

			toggleSearchMobile() {
				const headerInputSearch = document.querySelector('.header-search .search__input');

				headerInputSearch.click();
			}
		}
	);
}

/**
 * Open mobile nav
 */

if (!customElements.get('tpt-open-mobile-nav')) {
	customElements.define(
		'tpt-open-mobile-nav',
		class TptOpenMobileNav extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.openMobileNav.bind(this));
			}

			openMobileNav() {
				const modalTarget = this.getAttribute('data-modal-target');

				window.scroll({
					top: 0,
					left: 0,
				});

				setTimeout(() => {
					document.getElementsByTagName('html')[0].classList.toggle('open-modal');
					document.getElementById(modalTarget).classList.toggle('show');
				}, 200);
			}
		}
	);
}

/**
 * Toggle filter on desktop
 */
if (!customElements.get('tpt-toggle-filter')) {
	customElements.define(
		'tpt-toggle-filter',
		class TptToggleFilter extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.toggleFilter.bind(this));
			}

			toggleFilter() {
				document.body.classList.toggle('tpt-show-filter');
			}
		}
	);
}

/**
 * Show form customer header
 */
if (!customElements.get('tpt-toggle-customer-form')) {
	customElements.define(
		'tpt-toggle-customer-form',
		class TptToggleCustomerForm extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.toggleCustomerForm.bind(this));
			}

			toggleCustomerForm() {
				const formTargetId = this.getAttribute('data-target');
				const formCustomer = document.querySelectorAll('.header-customer__form');

				document.querySelector('.customer-dropdown__list').style.display = 'none';

				formCustomer.forEach((form) => {
					form.style.display = 'none';
				});

				document.getElementById(formTargetId).style.display = 'block';
			}
		}
	);
}

/**
 * Product card hover popup
 */
if (!customElements.get('tpt-product-card-hover')) {
	customElements.define(
		'tpt-product-card-hover',
		class TptProductCardHover extends HTMLElement {
			constructor() {
				super();
			}

			connectedCallback() {
				this.fetchUrl = '';
				this.sectionFetchId = '';
				this.dataStyle = this.getAttribute('data-style');
				const productHandle = this.getAttribute('data-product-handle');
				this.dataElement = this.querySelector('.product-card-wrapper__hover-data');
				this.appBoost = this.getAttribute('data-app');
				this.boostCardItem = this.closest('.boost-pfs-filter-product-item-inner');
				//this.boostProductCardExtendedData = this.boostCardItem.querySelector('.card__information-extend--data');

				/**
				 * Check if style boost_product set value window.productCardStyle
				 */
				if (this.dataStyle == 'boost_product') {
					this.dataStyle = window.productCardStyle;
				}

				if (this.dataStyle == 'extended') {
					this.sectionFetchId = 'product-card-hover-extended';
				}

				if (this.dataStyle == 'swatch_image') {
					this.sectionFetchId = 'product-card-hover-swatch-image';
				}

				if (this.dataStyle == 'swatch_color') {
					this.sectionFetchId = 'product-card-hover-swatch-color';
				}

				if (productHandle.includes('/products/')) {
					const strProductHandle = productHandle.split('/products/')[1];

					this.fetchUrl = `${window.Shopify.routes.root}products/${strProductHandle}?section_id=${this.sectionFetchId}`;
				} else {
					this.fetchUrl = `${window.Shopify.routes.root}products/${productHandle}?section_id=${this.sectionFetchId}`;
				}

				this.productCardHover();
			}

			productCardHover() {
				if (this.sectionFetchId) {
					fetch(this.fetchUrl)
						.then((response) => response.text())
						.then((responseText) => {
							const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');

							const sectionElement = responseHTML.querySelector('.shopify-section');

							if (this.dataElement) {
								this.dataElement.innerHTML = sectionElement.innerHTML;

								const thumbs = this.querySelectorAll('.product-card__hover-color--thumb');

								thumbs.forEach((item) => {
									item.addEventListener('click', this.changeOption.bind(this));
									//item.addEventListener('mouseover', this.changeOption.bind(this));
								});
							}

							/**
							 * Render data product card (BOOST APP)
							 */
							if (this.appBoost) {
								const productExtended = sectionElement.querySelector('.card__information-extend--data');
								const boostProductCardExtendedData = this.boostCardItem.querySelector('.card__information-extend--data-boost');

								const boostProductCardLabel = this.boostCardItem.querySelector('.card__information-label--boost');
								const labelHover = sectionElement.querySelector('.card__information-label--hover');

								const boostProductCardCompare = this.boostCardItem.querySelector('.card__information-compare--boost');
								const compareHover = sectionElement.querySelector('.card__information-compare');

								const boostProductSalePercent = this.boostCardItem.querySelector('.boost-pfs-filter-product-item-price');
								const salePercentHover = sectionElement.querySelector('.sale-percent__wrapper');

								if (labelHover && boostProductCardLabel) {
									boostProductCardLabel.innerHTML = labelHover.innerHTML;
								}

								if (compareHover && boostProductCardCompare) {
									boostProductCardCompare.innerHTML = compareHover.innerHTML;
								}

								if (productExtended && boostProductCardExtendedData) {
									boostProductCardExtendedData.innerHTML = productExtended.innerHTML;
								}

								if (boostProductSalePercent && salePercentHover) {
									boostProductSalePercent.append(salePercentHover);
								}

								if (this.dataStyle == 'swatch_color') {
									const colorSwatches = sectionElement.querySelector('.type-swatch-color');
									const boostProductCardColorSwatches = this.boostCardItem.querySelector('.type-swatch-color__inner');

									if (colorSwatches) {
										boostProductCardColorSwatches.innerHTML = colorSwatches.innerHTML;
									}
								}
							}
							/**
							 * End render data product card (BOOST APP)
							 */
						})
						.finally(() => {});
				}
			}

			changeOption(event) {
				const thumbs = this.querySelectorAll('.product-card__hover-color--thumb');
				const mainImage = this.querySelector('.product-card__hover-image');
				const mainLink = this.querySelector('.product-card__hover-link');
				const currentThumb = event.currentTarget;
				const curentThumbImage = currentThumb.getAttribute('data-image-url');
				const curentThumbUrl = currentThumb.getAttribute('data-product-url');
				const currentProductHandle = currentThumb.getAttribute('data-product-handle');
				const fetchUrl = `${window.Shopify.routes.root}products/${currentProductHandle}?section_id=${this.sectionFetchId}`;
				const infoElementUpdate = this.querySelector('.product-card__hover-infor--wrapper');

				thumbs.forEach((item) => {
					item.classList.remove('active');
				});

				currentThumb.classList.add('active');
				mainImage.setAttribute('src', curentThumbImage);
				mainLink.setAttribute('href', curentThumbUrl);

				infoElementUpdate.classList.add('loading');

				if (this.sectionFetchId) {
					fetch(fetchUrl)
						.then((response) => response.text())
						.then((responseText) => {
							const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');

							const infoData = responseHTML.querySelector('.product-card__hover-infor--wrapper');

							if (infoData) {
								infoElementUpdate.innerHTML = infoData.innerHTML;

								infoElementUpdate.classList.remove('loading');
							}
						})
						.finally(() => {});
				}
			}
		}
	);
}

/**
 * Simple modal
 */

if (!customElements.get('tpt-simple-modal-toggle')) {
	customElements.define(
		'tpt-simple-modal-toggle',
		class TptSimpleModalToggle extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.toggleSimpleModal.bind(this));
			}

			toggleSimpleModal() {
				const simpleModalId = this.getAttribute('data-target');

				document.getElementById(simpleModalId).classList.toggle('active');
			}
		}
	);
}

/**
 * Simple message
 */

if (!customElements.get('tpt-simple-message')) {
	customElements.define(
		'tpt-simple-message',
		class TptSimpleMessage extends HTMLElement {
			constructor() {
				super();
			}

			connectedCallback() {
				const buttonClose = this.querySelector('.tpt-simple-message__button');
				this.textHtml = this.querySelector('.tpt-simple-message__text');
				buttonClose.addEventListener('click', this.close.bind(this));
				this.timeOut = '';
			}

			message(type, message) {
				this.classList.remove('tpt-simple-message__error', 'tpt-simple-message__success', 'tpt-simple-message__warning');
				this.textHtml.innerHTML = message;
				this.classList.add('tpt-simple-message__' + type);
			}

			show() {
				this.classList.add('active');

				const messageElement = this;

				this.timeOut = setTimeout(() => {
					messageElement.close();
				}, 4000);
			}

			close() {
				this.classList.remove('active');
				clearTimeout(this.timeOut);
			}
		}
	);
}

/**
 * Update data after click width item
 */

if (!customElements.get('tpt-width-item')) {
	customElements.define(
		'tpt-width-item',
		class TptWidthItem extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.renderProductData.bind(this));
			}

			renderProductData() {
				const fetchUrl = this.getAttribute('data-product-url');
				const productUrl = this.getAttribute('data-product-link');
				const productInfoData = document.querySelector('#mainProductPage');
				productInfoData.classList.add('loading');

				fetch(fetchUrl)
					.then((response) => response.text())
					.then((responseText) => {
						const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');

						const infoData = responseHTML.querySelector('#mainProductPage');

						productInfoData.innerHTML = infoData.innerHTML;

						/**
						 * Re-render scripts
						 */
						productInfoData.querySelectorAll('script').forEach((oldScriptTag) => {
							const newScriptTag = document.createElement('script');
							Array.from(oldScriptTag.attributes).forEach((attribute) => {
								newScriptTag.setAttribute(attribute.name, attribute.value);
							});
							newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
							oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
						});

						/**
						 * Update url
						 */

						window.history.replaceState({}, '', `${productUrl}`);
					})
					.finally(() => {
						productInfoData.classList.remove('loading');
					});
			}
		}
	);
}

/**
 * Validate password
 */

if (!customElements.get('tpt-validate-password')) {
	customElements.define(
		'tpt-validate-password',
		class TptValidatePassword extends HTMLElement {
			constructor() {
				super();
			}

			connectedCallback() {
				const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).{8,20}$/;
				const inputs = this.querySelectorAll('[type="password"]');
				const btnSubmit = this.closest('form').querySelector('[type="submit"]');

				inputs.forEach((input)=>{
					input.addEventListener('input', () => {
						const value = input.value;
						console.log(btnSubmit);
						
						if (!value) {
							btnSubmit.setAttribute('disabled', true);
							return;
						}

						if (!regex.test(value)) {
							btnSubmit.setAttribute('disabled', true);
						} else {
							btnSubmit.removeAttribute('disabled');
						}
					});
				});
			}
		}
	);
}

/**
 * Show more button
 */

if (!customElements.get('tpt-more-button')) {
	customElements.define(
		'tpt-more-button',
		class TptShowMore extends HTMLElement {
			constructor() {
				super();

				const moreDataContainer = this.closest('tpt-more-data');
				const maxHeight = moreDataContainer.getAttribute('data-max-height');
				const dataHeight = moreDataContainer.querySelector('.tpt-more-element').offsetHeight;

				if (dataHeight > parseInt(maxHeight)) {
					moreDataContainer.classList.add('has-more-data');
				}

				this.addEventListener('click', this.toggleMore.bind(this));
				this.addEventListener('keypress', this.keyPress);
			}

			keyPress(e) {
				if (e.key === 'Enter') {
					this.toggleMore();
				}
			}

			toggleMore() {
				this.classList.toggle('active');
				this.closest('tpt-more-data').classList.toggle('active');
			}
		}
	);
}
